<template>
  <div>
  <L1>
    <template slot="slot_title">
      <RT :style="{marginLeft: 'auto', marginRight: '32px'}" :options="['概要', '預約詳情']" :defaultValue="page" @input="page=$event"></RT>
    </template>
    <L2 :ratio="'1fr 500px'" id="restCalendar">
      <Calendar slot="left" :dateSelect="date" @datechange="date=$event" @monthchange="start=$event" :startDate="start" :holidays="holidays">
        <template slot="calendarTop">
          <Select1 :width="'-webkit-fill-available'" :height="'50px'" :defaultValue="eventID" @input="eventID=$event">
            <option v-for="(rest, r) in events" :key="`restaurants-${r}`" :value="rest._id">{{rest.name}} ({{toDate(rest.startDate)}} ~ {{toDate(rest.endDate)}})</option>
          </Select1>
        </template>
        <template  slot-scope="{d}">
        <div v-if="results&&results[d]&&results[d].disabled&&!results[d].group" class="fulled" :title="results[d].disabled&&'關閉'">
          關
        </div>
        <div v-else-if="results&&results[d]&&results[d].num" class="dayresult">
          <div class="fulled2" v-if="results[d].disabled">{{results[d].disabled||'關閉'}}</div>
          <div>預約<span>{{results[d].group}}</span>組</div>
          <div>預約<span>{{results[d].num}}</span>人</div>
        </div>
        </template>
      </Calendar>
      <CSide :date="date">
        <template v-if="page==='概要'">
          <template v-if="dataSelected">
          <Select1 :width="'-webkit-fill-available'" :defaultValue="dataSelected.disabled" @input="updateStatus($event)" :class="dataSelected.disabled ? 'highlight' : ''">
            <option :value="false">開放預約</option>
            <option :value="true" :style="{color: 'var(--highlight)'}">關閉</option>
          </Select1>
          <template  v-for="(sum, s) in statuses">
            <hoverSelectVue :disabled="sum.reason" @input="updateStatus2" :key="`sum-${s}`" :style="{marginBlock: '15px'}" v-if="sum" class="day-hour-summary"
            :s="s" :sum="sum" :d="date" @update="()=>{}">
            </hoverSelectVue>
          </template>
          </template>
        </template>
        <template v-else>
          <div  class="sessList">
            <div v-for="(sess, s) in dataSelected.statuses" :key="`sess-${s}`" @click="bookingList=sess" :class="bookingList?.time===sess.time?'selected':''">
              {{sess.time}}
            </div>
          </div>
          <div class="sessInfo" v-if="bookingList">
            <div>
              <div>時段剩餘名額</div>
              <div> <span>{{eventSelect.limitNum - (bookingList.summary || []).map(e => e.reserveNum).reduce((a, b) => a + b, 0)}}</span>大 </div>
              <div> <span>{{eventSelect.limitNumChild - (bookingList.summary || []).map(e => e.reserveNumChild).reduce((a, b) => a + b, 0)}}</span>小 </div>
            </div>
            <div>
              <div>大人 <span>{{(bookingList.summary||[]).map(e => e.reserveNum).reduce((a, b) => a + b, 0)}}</span>位 </div><div> 兒童<span>{{(bookingList.summary||[]).map(e => e.reserveNumChild).reduce((a, b) => a + b, 0)}}</span>位 </div>
            </div>
          </div>
          <div v-if="bookingList&&bookingList.summary">
            <div v-for="(item, ss) in bookingList.summary" :key="`sum-${ss}`" @click="itemSelect=item" class="sessDetail">
              <div>
                <div>{{item.field_name}}</div>
                <div>{{item.field_tel}}</div>
              </div>
              <div>
                <div :style="{marginLeft: 'auto'}"><span>{{item.reserveNum}}</span>大 </div><div><span>{{item.reserveNumChild}}</span>小 </div>
              </div>
            </div>
          </div>
        </template>
      </CSide>
    </L2>
  </L1>
  <InfoSlider :icon="'balloon'" :show="!!itemSelect" @close="itemSelect=null" label="活動資訊" :width="481">
    <EditEventComp :style="{padding: '10px 32px', gap: '20px', display: 'flex', flexDirection: 'column', overflowY: 'auto'}" v-if="itemSelect"
    :sessions="eventSelect.session"
    :eventType="eventSelect.eventType"
    :eventId="event"
    :item="itemSelect" @close="itemSelect=null" @updateItem="updateItem"
    />
    <button  @click="showCheckin(itemSelect._id)" class="headerbtn" slot="headerbtn">報到</button>
  </InfoSlider>
</div>
</template>

<script>
import CSide from '../../components/calendarSide.vue'
import L2 from '../../components/layout/La1.vue'
import Calendar from '../../components/calendar2.vue'
import { getapi, postapi } from '../../store/fetch'
// import hourVue from './calendar/hour.vue'
import hoverSelectVue from './calendar/hourSwitch.vue'
import L1 from '../../components/layout/L1.vue'
import InfoSlider from '../../components/infoSlider_v2.vue'
import EditEventComp from './booking/editEventBooking.vue'
export default {
  components: {
    L2,
    CSide,
    Calendar,
    // hourVue,
    InfoSlider,
    EditEventComp,
    hoverSelectVue,
    L1
  },
  data () {
    return {
      reasons: ['預約額滿', '店休'],
      page: '概要',
      wdy: ['一', '二', '三', '四', '五', '六', '日'],
      start: this.moment().startOf('month').format('yyyy-MM-DD'),
      date: this.moment().format('yyyy-MM-DD'),
      result: null,
      results: null,
      summary: [],
      eventID: null,
      events: [],
      itemSelect: null,
      statuses: [],
      bookingList: null,
      holidays: []
    }
  },
  computed: {
    eventSelect () {
      return this.events.find(e => e._id === this.eventID)
    },
    dateReason () {
      return !!(this.dataSelected?.reason)
    },
    dataSelected () {
      if (this.results && this.date && this.results[this.date]) {
        return this.results[this.date]
      } else {
        return null
      }
    },
    startWdy () {
      return this.moment(this.start).weekday() - 1 % 7
    },
    endWdy () {
      return 7 - ((this.moment(this.start).endOf('month').weekday() - 1) % 7 + 1)
    },
    duration () {
      return this.moment(this.start).endOf('month').diff(this.moment(this.start), 'day')
    }
  },
  async mounted () {
    const holidays = await getapi('holidays')
    this.holidays = holidays.map(e => this.moment(e.date).format('YYYY-MM-DD'))
    const events = await getapi('eventSetting/list?' + new URLSearchParams({
    }))
    this.events = events
    this.eventID = events[0]._id
  },
  watch: {
    dataSelected: {
      deep: true,
      handler () {
        if (this.dataSelected) {
          this.statuses = this.dataSelected.statuses
        } else {
          this.statuses = []
        }
      }
    },
    async eventID () {
      if (this.eventID) {
        await this.getdata()
      }
    },
    async start () {
      await this.getdata()
    }
  },
  methods: {
    async updateStatus2 ({ time, value }) {
      console.log(value)
      const r = await postapi(`eventSetting/${this.eventID}/session/${value ? 'push' : 'pull'}`, {
        date: this.moment(this.date).toISOString(),
        time
      })
      if (r) {
        await this.getdata()
      }
    },
    async updateStatus (ev) {
      const r = await postapi(`eventSetting/${this.eventID}/session/disabled`, {
        date: this.moment(this.date).toISOString(),
        disabled: ev
      })
      if (r) {
        await this.getdata()
      }
    },
    async getdata () {
      const r = await getapi(`events/${this.eventID}/calendar?${new URLSearchParams({
        m: this.moment(this.start).month(),
        y: this.moment(this.start).year()
      })}`)
      this.results = r.dates
    }
  }
}
</script>
<style lang="scss">
#restCalendar {
  gap: 0;
  * {
    box-sizing: border-box;
  }
  .La1_left {
    padding: 34px 45px;
    overflow-y: hidden;
  }
  .La1_right {
    padding: 34px 32px 44px 1px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }
  .highlight > select {
    color: var(--highlight);
  }
}
</style>
<style lang="scss" scoped>
.sessDetail {
  box-shadow: 0px 0px 10px 0px #00000040;
  margin-top: 20px;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  padding-block: 10px;
  gap: 10px;
  font-size: 20px;
  line-height: 27px;
  letter-spacing: .1em;
  font-weight: 500;
  font-family: 'Noto Sans TC';
  &>div{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-inline: 20px;
    gap: 25px;
    span {
      font-size: 24px;
      font-weight: 700;
      color: var(--highlight);
      margin-inline: .5em;
    }
  }
}
.sessInfo {
  &>div{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    font-size: 18px;
    padding-inline: 10px;
    span {
      margin-inline: 1em;
      color: var(--highlight);
      font-weight: 900;
    }
  }
  &>div:nth-child(1){
    &>div:nth-child(2), &>div:nth-child(3) {
      font-weight: 900;
    }

  }
  &>div:nth-child(2){
    background-color: var(--color-bar);
    padding-inline: 25px;
  }
}
.sessList {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  flex-wrap: wrap;
  margin-inline: auto;
  padding: 0 0 10px 0;
  &>div{
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid var(--color-pri);
    background-color: #FFFFFF;
    color: var(--color-pri);
    padding: 10px 15px 10px 15px;
    border-radius: 20px;
    font-family: Roboto;
    font-weight: 600;
    font-size: 18px;
    line-height: 1em;
    letter-spacing: .1em;
    &.selected {
      background-color: var(--color-pri);
      color: #FFFFFF;
    }
  }
}

.fulled2 {

  background-color: var(--highlight);
  color: #FFFFFF;
  font-family: 'Roboto';
  font-style: normal;
  letter-spacing: 0.1em;
  width: fit-content;
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 2px 4px;
  border-radius: 2px;
  display: flex;
  text-align: center;
  // max-width: 3em;
}
.fulled {
  width: 74px;
  height: 74px;
  background-color: var(--highlight);
  border-radius: 45px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.1em;
}
.dayresult {
  padding-bottom: 10px;
  &>div {
    span {
      display: inline-flex;
      font-weight: 700;
      font-size: 20px;
      line-height: 150%;
      text-align: center;
      letter-spacing: 0.05em;
      color: #787878;
      width: 73px;
      align-items: center;
      justify-content: center;

    }
  }
}
.side-content {
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  text-align: start;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1em;
  color: #787878;
  gap: 15px;

}
.staff {
  margin-inline: auto;
  margin-bottom: 10px;
  height: 35px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  width: 130px;
  background-color: var(--color-bar);
  letter-spacing: .1em;
  &.pt {
    background-color: rgba(255, 228, 228, 0.9);
  }

}
.celendar {
  max-height: calc(100vh - 195px);
  padding-inline: 5px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-radius: 5px;
  overflow: auto;
  padding-bottom: 20px;
  box-sizing: border-box;
  &>div{
    flex:1;
  }
  .wdy {
    background-color: var(--color-pri);
    color: #FFFFFF;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 24px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.1em;
    &:nth-child(1) {
      border-radius: 5px 0 0 0;
    }
    &:nth-child(7) {
      border-radius:  0 5px 0 0;
    }
  }
  .day {
    min-height: 100px;
    min-height: 147px;
    border-right: 1px solid #DADADA;
    border-bottom: 1px solid #DADADA;
    &:nth-of-type(7n-6) {
      border-left: 1px solid #DADADA;
    }
    &>div:nth-child(1) {
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      text-align: center;
      letter-spacing: 0.1em;
      color: var(--color-pri);
      padding-block: 10px;
    }
    &.selected {
      background-color: var(--color-bar);
    }
  }
}
#div1{
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding-inline: 5px;
  &>div{
    min-width: 290px;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-pri);
  }
  button {
    background-color: transparent;
  }
}
#attendance-page3 {
  display: grid;
  flex: 1;
  max-height: calc(100vh - 90px);
  grid-template-rows: 100%;
  grid-template-columns: 310px 1fr;
  &>div{
    flex: 1;
    padding-block: 20px;
    padding-inline: 20px;
    overflow-y: auto;
    height: -webkit-fill-available;
  }
  padding-inline: 47px 22px;
}
</style>
